// src/styles/messenger/layout.style.ts
import { styled } from '../stitches.config';
import { NAVIGATION_HEIGHT } from '../../constants/global';
import {  Clock, SendFill } from 'react-bootstrap-icons';
import { AlertCircle, SendHorizontal, X, CheckCircle2, CheckCircle} from 'lucide-react';

const ButtonBase = styled('button', {
  padding: '0.5rem 1rem',
  border: 'none',
  borderRadius: 8,
  fontSize: '$sm',
  fontWeight: 600,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out',
  display: 'flex',
  alignItems: 'center',      // This vertically centers the icon and text
  justifyContent: 'center', // This horizontally centers them as a group
  gap: '0.5rem',            // This creates the gap between the icon and text
});

export const ReadReceipt = styled('div', {
  fontSize: '$xs',
  color: '$slate11',
  textAlign: 'right',
  // paddingRight: '1rem',
  height: '1rem', // Give it a fixed height
});

// in your main styles file

// A wrapper for the main text and status icon to align them correctly


// A wrapper for the status icon itself to control color and size
export const StatusIconWrapper = styled('div', {
  stroke: 'dodgerBlue', // Default color for the 'Sent' icon
  flexShrink: 0, // Prevents the icon from being squashed
  '&svg': {
    fill: 'dodgerBlue',
  },
  
  // Variants for the 'Read' state
  variants: {
    isRead: {
      true: {
        fill: '$blue9', // A solid blue for the 'Read' icon background
        '& svg': {
          stroke: 'white', // The tick mark itself will be white
        }
      }
    }
  }
});

export const PendingClock = styled (Clock, {
  fill: 'dodgerBlue',
  
})

export const SentCircle = styled(CheckCircle2, {
  // background: 'dodgerBlue',
  stroke: 'dodgerBlue',
})

export const SeenCircle = styled(CheckCircle2, {
  fill: 'dodgerBlue',
  // background: 'dodgerBlue',
  stroke: 'white',
    // stroke: 'dodgerBlue',
})

export const AlertIcon = styled(AlertCircle, {
  stroke: 'red',
})


export const ConversationItem = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  padding: '0.75rem 1rem', // 12px 16px
  cursor: 'pointer',
  border: '0.1rem',
//   borderBottom: '1px solid $elementBorder',
borderRadius: '16px',
// paddingBottom: '0.5rem',
  transition: 'background-color 0.2s ease',

  // Style for the currently active conversation
  '&[data-active="true"]': {
    backgroundColor: '$blue3',
  },

  '&:hover': {
    backgroundColor: '$blue2',
  },
});

export const Avatar = styled('img', {
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  marginRight: '0.75rem', // 12px
  objectFit: 'cover',
  backgroundColor: '$slate5', // Placeholder color
});



export const ProfileInitial = styled('div', {
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  marginRight: '0.75rem', // 12px
  objectFit: 'cover',
  flexShrink: 0, // ✅ ADD THIS LINE. This prevents the avatar from shrinking.
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '600',
  textTransform: 'uppercase',


});

export const Avatar2 = styled('img', {
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  // marginRight: '0.75rem', // 12px
  objectFit: 'cover',
  backgroundColor: '$slate5', // Placeholder color
});

export const ProfileInitial2 = styled('div', {
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0, // ✅ ADD THIS LINE. This prevents the avatar from shrinking.
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '600',
  textTransform: 'uppercase',
});


// export const ConversationInfo = styled('div', {
//   display: 'flex',
//   flexDirection: 'column',
//   overflow: 'hidden', // Prevents long names from breaking layout
// });

export const SecondaryButton = styled(ButtonBase, {
  background: 'transparent',
  color: '$sand12',
  // border: '1px solid $sand12',
  '&:hover': {
    background: '$sand4',
  }
});

// export const ConversationName = styled('span', {
//   fontWeight: 600,
//   color: '$slate12',
// });

// export const LastMessage = styled('span', {
//   color: '$slate11',
//   fontSize: '$sm',
//   whiteSpace: 'nowrap',
//   overflow: 'hidden',
//   textOverflow: 'ellipsis',
// });


export const ModalOverlay = styled('div', {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'grid',
    placeItems: 'center',
    zIndex: 1000, // Ensure it's on top of everything
  });
  
  export const ModalContent = styled('div', {
    background: 'white',
    padding: '1.5rem',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  });
  
  export const ModalHeader = styled('h3', {
    margin: 0,
    fontSize: '$md',
    fontWeight: 600,
    color: '$slate12',
  });
  
  export const ModalBody = styled('p', {
    margin: 0,
    color: '$slate11',
    fontSize: '$sm',
    paddingTop: '1rem',
    borderTop: '1px solid $separator',
    // paddingBottom: '1rem',
    // borderBottom: '1px solid $separator',

    // lineHeight: 1.5,
  });
  
  export const ModalFooter = styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '0.75rem',
    paddingTop: '1rem',
    borderTop: '1px solid $separator',
    // rowGapTop: '0.5rem',
    fontSize: '$sm',
    marginTop: '1rem',
  });
  

  export const InputBarWrapper = styled('div', {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 1rem',
    gap: '0.75rem',
    borderTop: '1px solid $elementBorder',
    background: '$blueWeeks',
    'svg': {
      transform: 'rotate(+45deg)',
    },
  
  });
  
  export const StyledIconButton = styled('button', {
    all: 'unset',
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    color: 'dodgerblue',
    transition: 'transform 0.1s ease',
    '&:active': {
      transform: 'scale(0.9)',
    },
  });
  
  export const MessageInputContainer = styled('div', {
    flex: 1,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    background: '#f5f5f5', 
    margin: '0.1rem',
    borderRadius: '18px',
    padding: '0 1rem',
  });
  
  export const SendIcon = styled(SendFill, {
    fill: 'var(--colors-blue11)'
    
    
  })


  export const GapCover = styled ('div', {
    position: 'fixed',
    background: '#f0f2f5',
    zIndex: 2,
    left: 0,           //  <-- Also add left and right
    right: 0,   
    // right: 0,   
    top: 0,
    bottom: `calc(100vh - (${NAVIGATION_HEIGHT} + 2rem))`,

})

export const BottomGapCover = styled ('div', {
    position: 'fixed',
    background: '#f0f2f5',
    zIndex: 2,
    left: 0,           
    right: 0,      
    height: '2rem',
    bottom: 0,

})
  export const MessageTextarea = styled('textarea', {
    flex: 1,
    border: 'none',
    background: 'transparent',
    padding: '0.5rem 0', // 8px padding top/bottom
    resize: 'none', // Disable manual resize handle
    outline: 'none',
    fontSize: '$md',
    fontFamily: 'inherit',
    maxHeight: '100px', // Prevent it from growing too tall
    overflowY: 'auto',
    color: '$slate12',
  });

  export const MessageWrapper = styled('div', {
    display: 'flex',
    marginBottom: '0.5rem',
    padding: '0 0.5rem',

  
    // Variants for sent vs. received messages
    variants: {
      sentByMe: {
        true: {
          justifyContent: 'flex-end', // Align to the right
        },
        false: {
          justifyContent: 'flex-start', // Align to the left
        },
      },
    },
  });
  
  // The inner bubble controls the color and shape
  export const MessageBubble = styled('div', {
    // maxWidth: '50%',
    // maxWidth: '70%', 
  
    // 👇 THIS IS THE FIX
    width: 'fit-content',

    padding: '0.5rem 1rem',
    borderRadius: '18px',
    lineHeight: '1.4',
    overflowWrap: 'break-word', // Breaks long words ONLY if they would overflow
    wordBreak: 'normal',       // Ensures text wraps at spaces by default
  
    variants: {
      sentByMe: {
        true: {
          background: 'dodgerblue',
          color: 'white',
          borderBottomRightRadius: '4px',
          '& span': { color: 'white' }, 

        },
        false: {
          background: '#f5f5f5',
          color: '$slate12',
          // Creates the little "tail" on the bottom left
          borderBottomLeftRadius: '4px',
        },
      },
      status: {
        pending: {
          opacity: 0.6,
        },
        failed: {
          opacity: 0.6, 
          background: '#ff4d4d',
        },
      }
    },
  });

  export const ErrorMessage = styled('div', {
    fontSize: '$xs',
    color: 'red',
    textAlign: 'right',
    paddingRight: '1rem',
    marginTop: '0.25rem',
  
    '& button': {
      all: 'unset',
      cursor: 'pointer',
      color: 'dodgerblue',
      marginLeft: '0.5rem',
      textDecoration: 'underline',
    },
  });

  export const RetryButton = styled('button', {
    all: 'unset',
    cursor: 'pointer',
    color: '$slate11',
    fontSize: '$xs',
    marginLeft: '0.5rem',
    '&:hover': { textDecoration: 'underline' },
  });

  export const TimestampSeparator = styled('div', {
    textAlign: 'center',
    fontSize: '0.75rem',
    padding: '1rem 0',
    fontWeight: 500,
    // color: 'black'



  })

  export const PreviewWrapper = styled('div', {
  padding: '8px 16px',
  backgroundColor: '#f',
  borderTop: '1px solid $separator',
  borderLeft: '4px solid $blueWeeks',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  });


export const Content = styled('div', {
  fontSize: '0.9rem',
  });
  

  


export const SenderName = styled('div', {
  fontWeight: 600,
  // color: 'black',
  });

export const XButton = styled(X, {
  stroke: 'var(--colors-blue11)'
})
  


export const MessageSnippet = styled('p', {
  margin: 0,
  // color: 'black',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis', 
  maxWidth: '300px',
  });
  

  export const MessageRow = styled('div', {
    position: 'relative', // Crucial for positioning the actions
    display: 'flex',
    margin: '0.25rem 0',
    justifyContent: 'flex-start', // Default alignment

    // This makes the action icons appear on hover
    '&:hover': {
        '.message-actions': {
            opacity: 1,
        }
    },
    variants: {
      // 👇 ADD THIS NEW VARIANT
      isNewGroup: {
        true: {
          marginTop: '1.5rem', // Larger margin for the first message in a new group
        }
      },
    }
    // Variants for sent vs. received messages
    // variants: {
    //   sentByMe: {
    //     true: {
    //       // flexDirection: 'row-reverse', // 👇 THIS IS THE KEY CHANGE
    //       justifyContent: 'flex-end', // Align to the right
    //     },
    //   },
    // },
});



export const MessageGroup = styled('div', {
  display: 'flex',
  maxWidth: '70%', 
  
  // 👇 THIS IS THE FIX
  // width: 'fit-content',
  // alignItems: 'center',

  // Variants for sent vs. received messages
  variants: {
      sentByMe: {
          true: {
              // This pushes the entire group to the far right of the MessageRow
              marginLeft: 'auto', 
              // This reverses the order of Bubble and Actions within the group
              flexDirection: 'row-reverse',
          },
          false: {
              // This pushes the entire group to the far left
              marginRight: 'auto',
          }
      }
  }
});

export const MessageActions = styled('div', {
  className: 'message-actions', // This class is targeted by the hover effect above
  display: 'flex',
  alignItems: 'center',
  opacity: 0, // Hidden by default
  transition: 'opacity 150ms ease-in-out',
  margin: '0 8px',
});

// NEW: A generic, unstyled button for icons
export const ActionIconButton = styled('button', {
    all: 'unset',
    display: 'grid',
    placeItems: 'center',
    cursor: 'pointer',
    color: '$slate11', // Assumes a 'slate11' token in your theme
    padding: '4px',
    borderRadius: '50%',
  
    '&:hover': {
      backgroundColor: '$slate3', // Assumes a 'slate3' token
      color: '$slate12',
    },
});


// NEW: The block for showing the message being replied to
export const RepliedMessageBlock = styled('div', {
  padding: '6px 10px',
  background: '$slate2', // Using a theme token is better than a fixed color
  // borderLeft: '3px solid $blue9', // Use your theme's primary color token
  borderRadius: '4px',
  marginBottom: '6px',
  fontSize: '$sm',

  variants: {
    sentByMe: {
      true: {
        borderLeft: '3px solid $blue7',
        background: '$blue5'
      },
      false: {
        borderLeft: '3px solid $blue9',
      }
    }
  },

  '& > p': {
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '250px',
  },
});



// NEW: Style for the original sender's name in a reply
export const RepliedSenderName = styled('p', {
  fontWeight: 600,

  variants: {
    sentByMe: {
      true: {
        // color: 'white'

      },
      false: {
        color: '$blue11',
      }
    }
  },
  // color: '$blue11', // Use your theme's primary color token
});



export const InlineTimestamp = styled('span', {
  fontSize: '0.7rem',
  color: '$slate10',
  marginLeft: '0.75rem',
  alignSelf: 'flex-end', // Aligns to the bottom-right of a flex container
  whiteSpace: 'nowrap',
});

export const MessageContent = styled('div', {
  display: 'flex',
  alignItems: 'flex-end', // Aligns message text and timestamp correctly
  // gap: '0.5rem',
});

export const MessageText = styled('span', {
  // These properties ensure text wraps correctly and naturally
  overflowWrap: 'break-word',
  wordBreak: 'normal',
});


// src/styles/messenger/messenger.style.ts

// 1. Add a MessageTimestamp component
// export const MessageTimestamp = styled('span', {
//   fontSize: '$xs',
//   color: '$sand9',
//   marginLeft: 'auto', // Pushes the timestamp to the far right
//   paddingLeft: '0.5rem',
//   flexShrink: 0, // Prevents the timestamp from shrinking
// });

export const MessageTimestamp = styled('span', {
  fontSize: '$sm',
  color: '$slate11', // Same grey as message
  whiteSpace: 'nowrap',
  flexShrink: 0, // Never squash the time
});

// 2. Update ConversationInfo to use flexbox
// export const ConversationInfo = styled('div', {
//   flexGrow: 1,
//   display: 'flex', // Use flexbox for alignment
//   alignItems: 'center', // Vertically align items
//   overflow: 'hidden', // Hide overflow
// });

export const ConversationInfo = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start', // Start from top
  flex: 1, 
  minWidth: 0, 
  
  // 👇 OPTIONAL TWEAK: 
  // Sometimes the font's "cap height" sits lower than the image top.
  // Add a tiny margin here if the text looks 1-2px too high.
  marginTop: '2px', 
});

// 3. Create a wrapper for Name and Last Message
export const NameAndMessage = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden', // Important for text truncation
});

// 4. Update ConversationName to accept an 'isUnread' prop
export const ConversationName = styled('div', {
  fontWeight: 500,

  whiteSpace: 'nowrap',
  flexShrink: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  
  // 👇 THIS IS THE KEY:
  // It tells the Name to take up all empty space, pushing tags to the right.
  // flexGrow: 1, 
  
  // Ensures the name truncates if space runs out, rather than crushing the tags
  minWidth: 0,
  // ... other styles
  variants: {
    isUnread: {
      true: {
        fontWeight: 700, // BOLD
        color: '$sand12',
      }
    }
  }
});


// 5. Update LastMessage for unread state and text truncation
// export const LastMessage = styled('div', {
//   fontSize: '$sm',
//   color: '$sand11',
//   whiteSpace: 'nowrap',
//   overflow: 'hidden',
//   textOverflow: 'ellipsis', // Adds '...' if the text is too long
//   variants: {
//     isUnread: {
//       true: {
//         fontWeight: 600, // BOLD
//         color: '$sand12', // Make it darker
//       }
//     }
//   }
// });

export const LastMessage = styled('span', {
  fontSize: '$sm', // approx 13px or 14px
  color: '$slate11', // Grey text
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  
  // Remove 'flex: 1' so it doesn't push the time away unnecessarily,
  // BUT we need 'flex-shrink: 1' so it truncates if the line gets too long.
  flexShrink: 1, 

  variants: {
    isUnread: {
      true: { fontWeight: 600, color: '$slate12' } // Bold/Dark if unread
    }
  }
});

// export const NameAndTagsContainer = styled('div', {
//   display: 'flex',
//   alignItems: 'center',
//   gap: '0.5rem',
//   minWidth: 0, // Crucial: allows this container to shrink so the text truncation works
//   width: '100%',
// });
export const NameAndTagsContainer = styled('div', {
  display: 'flex',
  
  // ✅ FIX 1: Must be 'center' (vertical). 'space-between' is invalid here.
  alignItems: 'center', 
  
  // ✅ FIX 2: Must be 'flex-start'. 'space-between' pushes tags to the far right wall.
  justifyContent: 'flex-start',
  
  // ✅ FIX 3: This is the command that adds the space between Name and TagWrap.
  gap: '0.5rem', 
  
  width: '100%',
  minWidth: 0,
  lineHeight: 1, 
});
// Container for the tag "bubbles"
export const TagWrap = styled('div', {
  display: 'flex',
  alignItems: '',
  gap: '0.25rem', // tighter gap for the list view
  
  // Force single line behavior
  flexWrap: 'nowrap', 
  flexShrink: 1, 
  
  // Hide overflow so it doesn't break layout
  overflow: 'hidden',
  
  // Allow it to take remaining space after the name, but shrink if needed
  minWidth: 0,

  // The Fade Out Effect: makes it look polished instead of "cutting off halfway"
  // maskImage: 'linear-gradient(to right, black 80%, transparent 100%)',
  // WebkitMaskImage: 'linear-gradient(to right, black 80%, transparent 100%)',

  // Ensure the individual Tag pills don't get squashed/distorted
  '& > div': {
    flexShrink: 0,
  },

  variants: {
    display: {
      true: {
      }, 
      false: {

      }
    },
    
    },
    defaultVariants: {
      display: 'false',
  }

});

export const Tag = styled('div', {
  fontWeight: 500,
  borderRadius: '9999px',
  fontSize: '0.8rem', // Slightly smaller for list view usually looks better
  padding: '0.1rem 0.5rem', // Add padding so text isn't against the edge
  background: '$blue3',
  color: '$blue11',
  whiteSpace: 'nowrap', // Ensure text inside tag doesn't wrap
  flexShrink: 0, 
  variants: {
    isMatch: {
      true: {
        background: '$green3',
        color: '$green11',
      },
      false: {
        background: '$blue3',
        color: '$blue11',
      }
    }
  },
  defaultVariant: { 
    isMatch: 'false',
  }
});

export const MessageMetaRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  
  // 👇 CHANGE FROM 'space-between' TO 'flex-start'
  // This keeps the time right next to the message
  justifyContent: 'space-between', 
  
  width: '100%',
  minWidth: 0,
  marginTop: '0.25rem', // Add small gap between Name and Message
});

export const Overlay = styled('div', {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overscrollBehavior: 'none',
});

export const Dialog = styled('div', {
  width: 'min(920px, 96dvw)', maxHeight: '90dvh', overflow: 'auto', background: 'white', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.25)', overscrollBehavior: 'none',
});